var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("select", { staticClass: "form-control", attrs: { id: _vm.id } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }